import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import '../../assets/css/component/Input.css'
import Select from 'react-select'

export default class SelectInput extends Component {
    render() {
        const { label_name, placeholder,loading, disabled,options,onInputChange, closeMenu, name, defaultValue, onChange, onBlur, error } = this.props
        return (
            <>
                <Form.Group className="mb-3" controlId="">
                    <Form.Label className='form_label'>{label_name}</Form.Label>
                    <Select
                        closeMenuOnSelect={closeMenu}
                        placeholder={placeholder}
                        isDisabled={disabled}
                        options={options}
                        className='react_select'
                        classNamePrefix="select"
                        name={name}
                        style={{menu: (provided) => ({
                            ...provided,
                            zIndex: 99999999 // Adjust the value as needed
                            
                        })}}
                        onInputChange={onInputChange}
                        defaultValue={defaultValue}
                        onChange={onChange}
                        onBlur={onBlur}
                        isLoading={loading}
                    />
                    {error}
                </Form.Group>
            </>
        )
    }
}
